import { render, staticRenderFns } from "./Away.vue?vue&type=template&id=14729164"
import script from "./Away.vue?vue&type=script&lang=js"
export * from "./Away.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports